/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Index from "views/Index.js";
import Profile from "views/examples/Profile.js";
import Maps from "views/examples/Maps.js";
import Register from "views/examples/Register.js";
import Login from "views/examples/Login.js";
import Tables from "views/examples/Tables.js";
import Icons from "views/examples/Icons.js";
import ProvincesList from "views/content/ProvincesList.js";
import DealsList from "views/content/DealsList.js";

// Keşfet
import DiscoverHome from "views/discover/Home.js";
import MapPage from "views/discover/MapPage.js";

// İşletmeler
import BusinessesList from "views/businesses/BusinessesList.js";

// Kullanıcı
import ProfilePage from "views/profile/ProfilePage.js";
import MyBookings from "views/bookings/MyBookings.js";
import PaymentsPage from "views/payments/PaymentsPage.js";
import SavedPage from "views/saved/SavedPage.js";
import MyAlerts from "views/alerts/MyAlerts.js";

// Partner
import PartnerHome from "views/partner/PartnerHome.js";
import PartnerBookings from "views/partner/PartnerBookings.js";
import PartnerMyBusinesses from "views/partner/PartnerMyBusinesses.js";

// Admin
import AdminHome from "views/admin/AdminHome.js";
import AdminBusinesses from "views/admin/AdminBusinesses.js";
import AdminBookings from "views/admin/AdminBookings.js";
import AdminSubscriptions from "views/admin/AdminSubscriptions.js";
import AdminUsers from "views/admin/AdminUsers.js";
import AdminAlerts from "views/admin/AdminAlerts.js";
import AdminFavoritesOverview from "views/admin/AdminFavoritesOverview.js";
import { adminPaths } from "admin/paths";

var routes = [
  // ── Keşfet ──
  {
    path: adminPaths.dashboard,
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: <Index />,
    layout: "/admin",
  },
  {
    path: adminPaths.discover,
    name: "Keşfet",
    icon: "ni ni-compass-04 text-info",
    component: <DiscoverHome />,
    layout: "/admin",
  },
  {
    path: adminPaths.map,
    name: "Harita",
    icon: "ni ni-pin-3 text-orange",
    component: <MapPage />,
    layout: "/admin",
  },

  // ── İçerik Yönetimi ──
  {
    path: adminPaths.content.provinces.list,
    name: "İller (Yönetim)",
    icon: "ni ni-map-big text-info",
    component: <ProvincesList />,
    layout: "/admin",
  },
  {
    path: adminPaths.content.deals.list,
    name: "Fırsatlar (Yönetim)",
    icon: "ni ni-tag text-primary",
    component: <DealsList />,
    layout: "/admin",
  },

  // ── İşletmeler & Fırsatlar ──
  {
    path: adminPaths.businesses,
    name: "İşletmeler",
    icon: "ni ni-shop text-success",
    component: <BusinessesList />,
    layout: "/admin",
  },

  // ── Kullanıcı ──
  {
    path: adminPaths.profile,
    name: "Profilim",
    icon: "ni ni-single-02 text-yellow",
    component: <ProfilePage />,
    layout: "/admin",
  },
  {
    path: adminPaths.bookings,
    name: "Rezervasyonlarım",
    icon: "ni ni-calendar-grid-61 text-primary",
    component: <MyBookings />,
    layout: "/admin",
  },
  {
    path: adminPaths.payments,
    name: "Ödemelerim",
    icon: "ni ni-credit-card text-info",
    component: <PaymentsPage />,
    layout: "/admin",
  },
  {
    path: adminPaths.saved,
    name: "Kaydedilenler",
    icon: "ni ni-favourite-28 text-danger",
    component: <SavedPage />,
    layout: "/admin",
  },
  {
    path: adminPaths.alerts,
    name: "Bildirimler",
    icon: "ni ni-bell-55 text-warning",
    component: <MyAlerts />,
    layout: "/admin",
  },

  // ── Partner ──
  {
    path: adminPaths.partner.home,
    name: "Partner Panel",
    icon: "ni ni-building text-warning",
    component: <PartnerHome />,
    layout: "/admin",
  },
  {
    path: adminPaths.partner.bookings,
    name: "Partner Rez.",
    icon: "ni ni-calendar-grid-61 text-warning",
    component: <PartnerBookings />,
    layout: "/admin",
    invisible: true,
  },
  {
    path: adminPaths.partner.businesses,
    name: "Partner İşletmeler",
    icon: "ni ni-shop text-warning",
    component: <PartnerMyBusinesses />,
    layout: "/admin",
    invisible: true,
  },

  // ── Admin ──
  {
    path: adminPaths.admin.home,
    name: "Yönetim",
    icon: "ni ni-settings-gear-65 text-dark",
    component: <AdminHome />,
    layout: "/admin",
  },
  {
    path: adminPaths.admin.businesses,
    name: "İşletme Yönetimi",
    icon: "ni ni-shop text-dark",
    component: <AdminBusinesses />,
    layout: "/admin",
  },
  {
    path: adminPaths.admin.bookings,
    name: "Rezervasyon Yönetimi",
    icon: "ni ni-calendar-grid-61 text-dark",
    component: <AdminBookings />,
    layout: "/admin",
  },
  {
    path: adminPaths.admin.subscriptions,
    name: "Abonelik Yönetimi",
    icon: "ni ni-crown text-dark",
    component: <AdminSubscriptions />,
    layout: "/admin",
  },
  {
    path: adminPaths.admin.users,
    name: "Kullanıcı Yönetimi",
    icon: "ni ni-single-02 text-dark",
    component: <AdminUsers />,
    layout: "/admin",
  },
  {
    path: adminPaths.admin.alerts,
    name: "Uyarı Yönetimi",
    icon: "ni ni-bell-55 text-dark",
    component: <AdminAlerts />,
    layout: "/admin",
  },
  {
    path: adminPaths.admin.favorites,
    name: "Favori İstatistikleri",
    icon: "ni ni-chart-bar-32 text-dark",
    component: <AdminFavoritesOverview />,
    layout: "/admin",
  },

  // ── Eski / Araçlar ──
  {
    path: "/icons",
    name: "Icons",
    icon: "ni ni-planet text-blue",
    component: <Icons />,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/maps",
    name: "Maps (Eski)",
    icon: "ni ni-pin-3 text-orange",
    component: <Maps />,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/user-profile",
    name: "User Profile (Eski)",
    icon: "ni ni-single-02 text-yellow",
    component: <Profile />,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/tables",
    name: "Tables",
    icon: "ni ni-bullet-list-67 text-red",
    component: <Tables />,
    layout: "/admin",
    invisible: true,
  },

  // ── Auth ──
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: <Login />,
    layout: "/auth",
    invisible: true,
  },
  {
    path: "/register",
    name: "Register",
    icon: "ni ni-circle-08 text-pink",
    component: <Register />,
    layout: "/auth",
    invisible: true,
  },
];
export default routes;
